import React from 'react'
import useStore from '../../../../../StorePeople/Store'
// import uploadIcon from '../images/uploadSVG.svg';
// import uploadIcon from '../JobTitlePeople/images/uploadSVG.svg';
import uploadIcon from '../RealStatePeople/images/uploadSVG.svg'
import styles from './styles.module.css'

function LeadGeneration () {
  const { isQueryLoading, setTitle, setOrFields, setBusinessCategories } =
    useStore()

  const onClickBusinessCategoriesRealEstate = () => {
    if (isQueryLoading) return
    setTitle(
      'CEO,CFO,CTO,CPO,COO,CRO,VP,Vice President,director'
    )
     setOrFields(['emails', 'phoneNumbers'])
  }
  const onClickBusinessCategoriesTechnology = () => {
    if (isQueryLoading) return
    setBusinessCategories("banking")
    setOrFields(['emails', 'phoneNumbers'])
  }

  return (
    <section>
      <div className={styles.businessCategoriesContainer}>
        <h2 className={styles.businessCategoriesTitle}>Lead Generation</h2>
        <div className={styles.businessCategoriesValues}>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickBusinessCategoriesRealEstate}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>
                Contact info for company leadership
              </span>
              <p className={styles.businessCategoriesText}>
                Emails and phones for CXOs, VPs, and managers across all
                industries
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
          <div
            className={`${styles.businessCategoriesItem} ${
              isQueryLoading ? styles.businessCategoriesItemDisabled : ''
            }`}
            onClick={onClickBusinessCategoriesTechnology}
          >
            <div>
              <span className={styles.businessCategoriesSpan}>
                Contact info for people in a specific industry
              </span>
              <p className={styles.businessCategoriesText}>
                Emails and phones for people working in one industry (e.g.,
                banking)
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.businessCategoriesImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default LeadGeneration
